import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.vod-content {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
}

:global(.ot-floating-button) {
  display: none !important;
}

.vod-content-wrapper {
  /* leave space for header */
  min-height: calc(100vh - 56px);
}

.player-container {
  z-index: 1;
  flex: 1 1 auto;
  height: 100%;
}

.player-container-inner {
  position: relative;
  min-height: 500px;
  height: 100%;
  padding-top: 56.25%;
}

.episode-info-container {
  z-index: 1;
  flex: 1 1 auto;
}

.episode-info-inner {
  margin-bottom: 4em;
}

.mpu-container {
  display: flex;
  min-width: 300px;
  justify-content: center;
}

.no-player {
  aspect-ratio: 16/9;
  object-fit: fill;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.black};
  z-index: 1;
  margin-bottom: 15px;
  position: relative;
}

@media (min-width: 600px) {
  .episode-info-inner {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2em;
  }

  .mpu-container {
    margin-right: 24px;
    margin-top: 24px;
  }
}

@media (min-width: 900px) {
  .vod-content-wrapper {
    min-height: calc(100vh - 72px);
  }
}

@media (max-width: 500px){
  .player-container-inner {
    min-height: 550px;
  }
}
@media (min-width: 1024px) {
  .vod-content {
    flex-direction: row-reverse;
  }

  .episode-info-container {
    max-width: 372px;
  }

  .episode-info-inner {
    display: block;
  }

  .mpu-container {
    margin-right: 0;
    margin-top: 0;
  }
}
`
